import {Injectable} from '@angular/core';

export const MY_FORMATS = {
  parse: {
    dateInput: 'YYYY-MM-DD',
  },
  display: {
    dateInput: 'YYYY-MM-DD',
    monthYearLabel: 'YYYY MMM DD',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'YYYY MMMM',
  },
};

@Injectable()
export class UtilService {

  private smallScreenWidthLimit = 992;

  constructor() {
  }

  /**
   * Find item in array, return modified array if item exits.
   */
  public findAndReplaceItemInArray(item, array, deleteInstead = false) {
    if (!item || !array || array.length === 0) {
      return false;
    }
    const index = array.findIndex(el => el.id === item.id);

    if (index > -1) {
      if (deleteInstead === true) {
        array.splice(index, 1);
      } else {
        Object.assign(array[index], item);
      }
    }

    return array;
  }

  public findAndReplaceSimpleItemInArray(item, array, deleteInstead = false) {
    if (!item || !array || array.length === 0) {
      return false;
    }
    const index = array.findIndex(el => el === item);

    if (index > -1) {
      if (deleteInstead === true) {
        array.splice(index, 1);
      } else {
        Object.assign(array[index], item);
      }
    }

    return array;
  }

  /**
   * Is item exists in array
   */
  public isItemInArray(item, array) {
    return (array.findIndex(el => el.id === item.id) > -1);
  }

  /**
   * Check if the window is smaller then wihdowLimit
   */
  public isSmallScreen() {
    return window.innerWidth <= this.smallScreenWidthLimit;
  }

  /**
   * Returns the pressed keycode (borwser support)
   */
  public getPressedKeyCode(event) {
    let code;

    if (event.key !== undefined) {
      code = event.key;
    } else if (event.keyIdentifier !== undefined) {
      code = event.keyIdentifier;
    } else if (event.keyCode !== undefined) {
      code = event.keyCode;
    }

    return code;
  }

  /**
   * Material datatable sorting
   */
  public tableSorting(item, property: string) {
    const convertToLowercaseString = (input) => (typeof input === 'string' || input instanceof String) ? input.toLocaleLowerCase() : input;

    if (property.includes('.')) {
      const _prop = property.split('.');
      if (!item[_prop[0]]) {
        return false;
      } else {
        return _prop.reduce((o, i) => (o[i] ? convertToLowercaseString(o[i]) : false), item);
      }
    } else {
      return convertToLowercaseString(item[property]);
    }
  }

  public get8bitsfrom16bit(num) {
    let high = ((num >> 8) & 0xff);
    let low = num & 0xff;
    return [low,high];
  }

  public secondsToDhms(seconds) {
    seconds = Number(seconds);
    let d = Math.floor(seconds / (3600*24));
    let h = Math.floor(seconds % (3600*24) / 3600);
    let m = Math.floor(seconds % 3600 / 60);
    let s = Math.floor(seconds % 60);

    let dDisplay = d > 0 ? d + "d " : "";
    let hDisplay = h > 0 ? h + "h " : "";
    let mDisplay = m > 0 ? m + "m " : "";
    let sDisplay = s > 0 ? s + "s " : "";
    return dDisplay + hDisplay + mDisplay + sDisplay;
  }

  public convertRawMeasureRegistersToTableData(registersRaw) {
    const result = [];
    const registers = Object.entries(registersRaw);
    let count = 0;
    let name = '';
    let id = '';
    registers.forEach(([key, value]:[any,any]) => {
      switch (count) {
        case 0:
          id = 'start';
          name = 'Start address';
          break;
        case 1:
          id = 'type';
          name = 'Type';
          break;
        case 2:
          id = 'length';
          name = 'Length';
          break;
        case 3:
          id = 'neighbours';
          name = 'Neighbours';
          break;
        default:
          id = 'missing';
          name = 'missing';
      }
      result.push({
        id: id,
        name: name,
        value: value,
        register: key
      });
      count++;
    })

    return result;
  }
}
